// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 爱情树页面样式 */
.lovetree-page {
  min-height: 100vh;
  background: linear-gradient(135deg, 
    rgba(255, 248, 220, 0.95) 0%,  /* 淡黄色 */
    rgba(255, 250, 205, 0.9) 25%,  /* 浅柠檬色 */
    rgba(250, 235, 215, 0.85) 50%, /* 古董白 */
    rgba(255, 228, 181, 0.8) 75%,  /* 小麦色 */
    rgba(245, 222, 179, 0.75) 100% /* 小麦色深一点 */
  );
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 返回按钮 */
.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(139, 110, 99, 0.8);
  backdrop-filter: blur(10px);
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  z-index: 100;
}

.back-btn:hover {
  background: rgba(109, 76, 65, 0.9);
  transform: translateY(-2px);
}

/* 中心爱心容器 */
.heart-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
}

/* 爱心样式 */
.love-heart {
  width: 80px;
  height: 80px;
  position: relative;
  cursor: pointer;
  animation: heartPulse 1.5s ease-in-out infinite;
  transition: all 0.3s ease;
}

.love-heart:hover {
  transform: scale(1.1);
}

.love-heart::before,
.love-heart::after {
  content: '';
  width: 40px;
  height: 64px;
  position: absolute;
  left: 40px;
  transform: rotate(-45deg);
  background: linear-gradient(135deg, #ff1744, #e91e63, #ad1457);
  border-radius: 32px 32px 0 0;
  transform-origin: 0 100%;
  box-shadow: 0 4px 15px rgba(255, 23, 68, 0.3);
}

.love-heart::after {
  left: 0;
  transform: rotate(45deg);
  transform-origin: 100% 100%;
}

/* 点击提示文字 */
.click-hint {
  margin-top: 20px;
  font-size: 1.2rem;
  color: #d63384;
  font-weight: 600;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  animation: bounce 2s infinite;
}

/* 下落的红点 */
.falling-dot {
  width: 10px;
  height: 10px;
  background: radial-gradient(circle, #ff1744, #c51162);
  border-radius: 50%;
  position: absolute;
  box-shadow: 0 2px 8px rgba(255, 23, 68, 0.4);
  animation: fallDown 1.5s ease-in forwards; /* 缩短下落时间 */
}

/* 土壤线条 */
.soil-line {
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 8px;
  background: linear-gradient(to right, #8d6e63, #6d4c41, #5d4037);
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(93, 64, 55, 0.3);
  opacity: 1; /* 立即显示，不需要动画 */
}

/* 主树干 */
.tree-trunk {
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  animation: trunkGrow 2s ease-out 2s forwards; /* 提前到2秒开始 */
}

/* 主树干路径 */
.main-trunk {
  fill: none;
  stroke: url(#trunkGradient);
  stroke-width: 20;
  stroke-linecap: round;
  opacity: 0;
  animation: drawTrunk 2s ease-out 2s forwards;
}

/* 树枝 */
.tree-branch {
  fill: none;
  stroke: url(#branchGradient);
  stroke-linecap: round;
  opacity: 0;
}

.tree-branch.branch-1 {
  stroke-width: 12;
  animation: drawBranch 1.5s ease-out 4s forwards; /* 提前0.5秒 */
}

.tree-branch.branch-2 {
  stroke-width: 10;
  animation: drawBranch 1.5s ease-out 4.5s forwards;
}

.tree-branch.branch-3 {
  stroke-width: 8;
  animation: drawBranch 1.5s ease-out 5s forwards;
}

.tree-branch.branch-4 {
  stroke-width: 8;
  animation: drawBranch 1.5s ease-out 5.5s forwards;
}

/* 树叶容器 */
.tree-leaves {
  position: absolute;
  bottom: 20%; /* 与树干底部对齐 */
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 300px;
}

/* SVG树容器 */
.tree-svg-container {
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 300px;
  opacity: 0;
  animation: treeAppear 0.5s ease-out 2s forwards; /* 提前到2秒 */
}

/* 单个叶子（爱心形状） */
.leaf {
  position: absolute;
  width: 20px;
  height: 20px;
  opacity: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
  /* 以容器中心为基准点定位 */
  left: 50%;
  top: 50%;
  transform-origin: center;
}

.leaf:hover {
  transform: scale(1.2);
}

.leaf::before,
.leaf::after {
  content: '';
  width: 10px;
  height: 16px;
  position: absolute;
  left: 10px;
  transform: rotate(-45deg);
  border-radius: 8px 8px 0 0;
  transform-origin: 0 100%;
}

.leaf::after {
  left: 0;
  transform: rotate(45deg);
  transform-origin: 100% 100%;
}

/* 不同颜色的叶子 */
.leaf.yellow::before,
.leaf.yellow::after {
  background: linear-gradient(135deg, #ffd600, #ffb300);
  box-shadow: 0 2px 6px rgba(255, 214, 0, 0.3);
}

.leaf.red::before,
.leaf.red::after {
  background: linear-gradient(135deg, #ff1744, #e91e63);
  box-shadow: 0 2px 6px rgba(255, 23, 68, 0.3);
}

.leaf.orange::before,
.leaf.orange::after {
  background: linear-gradient(135deg, #ff6d00, #ff9100);
  box-shadow: 0 2px 6px rgba(255, 109, 0, 0.3);
}

.leaf.pink::before,
.leaf.pink::after {
  background: linear-gradient(135deg, #e91e63, #ad1457);
  box-shadow: 0 2px 6px rgba(233, 30, 99, 0.3);
}

.leaf.green::before,
.leaf.green::after {
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
}

/* 左侧诗句 */
.love-poem {
  position: absolute;
  left: 10%;
  top: 35%; /* 从 bottom: 30% 改为 top: 35% */
  font-size: 1.1rem;
  color: #5d4037;
  line-height: 1.8;
  font-weight: 500;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
  animation: poemAppear 3s ease-out 6s forwards;
}

.poem-line {
  opacity: 0;
  animation: typewriter 2s ease-out forwards;
}

.poem-line:nth-child(1) { animation-delay: 6s; }
.poem-line:nth-child(2) { animation-delay: 8s; }

/* 天数统计 */
.days-together {
  position: absolute;
  left: 10%;
  top: 50%; /* 从 bottom: 15% 改为 top: 50% */
  font-size: 1rem;
  color: #8d6e63;
  font-weight: 600;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
  animation: daysAppear 1s ease-out 10s forwards;
}

.days-number {
  color: #e91e63;
  font-size: 1.3rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(233, 30, 99, 0.2);
}

/* 动画定义 */
@keyframes heartPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-10px); }
  60% { transform: translateY(-5px); }
}

@keyframes fallDown {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0.8;
    transform: translateY(280px) scale(0.5); /* 调整下落距离，准确落在土壤上 */
  }
}

@keyframes soilAppear {
  from {
    opacity: 0;
    width: 0;
  }
  to {
    opacity: 1;
    width: 80%;
  }
}

@keyframes trunkGrow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes treeAppear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes drawTrunk {
  from {
    opacity: 0;
    stroke-dasharray: 200;
    stroke-dashoffset: 200;
  }
  to {
    opacity: 1;
    stroke-dasharray: 200;
    stroke-dashoffset: 0;
  }
}

@keyframes drawBranch {
  from {
    opacity: 0;
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
  }
  to {
    opacity: 1;
    stroke-dasharray: 100;
    stroke-dashoffset: 0;
  }
}

@keyframes leafGrow {
  from {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(360deg);
  }
}

@keyframes poemAppear {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes typewriter {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes daysAppear {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 隐藏状态 */
.hidden {
  display: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .love-heart {
    width: 60px;
    height: 60px;
  }
  
  .love-heart::before,
  .love-heart::after {
    width: 30px;
    height: 48px;
    left: 30px;
  }
  
  .love-heart::after {
    left: 0;
  }
  
  .click-hint {
    font-size: 1rem;
  }
  
  .love-poem {
    left: 5%;
    font-size: 0.9rem;
  }
  
  .days-together {
    left: 5%;
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LoveTreePage.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,iBAAiB;EACjB;;;;;;GAMC;EACD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,8DAA8D;EAC9D,4BAA4B;EAC5B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,yCAAyC,EAAE,WAAW;AACxD;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,gEAAgE;EAChE,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU,EAAE,eAAe;AAC7B;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,4CAA4C,EAAE,YAAY;AAC5D;;AAEA,UAAU;AACV;EACE,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,4CAA4C;AAC9C;;AAEA,OAAO;AACP;EACE,UAAU;EACV,4BAA4B;EAC5B,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,+CAA+C,EAAE,WAAW;AAC9D;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;AACf;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,+CAA+C,EAAE,UAAU;AAC7D;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;;EAEE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ,EAAE,8BAA8B;EACxC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,0CAA0C;AAC5C;;AAEA,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;;AAE/C,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ,EAAE,8BAA8B;EACxC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA,SAAS;AACT;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,0BAA0B,wBAAwB,EAAE;EACpD,MAAM,4BAA4B,EAAE;EACpC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,YAAY;IACZ,uCAAuC,EAAE,mBAAmB;EAC9D;AACF;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;AACF","sourcesContent":["/* 爱情树页面样式 */\n.lovetree-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, \n    rgba(255, 248, 220, 0.95) 0%,  /* 淡黄色 */\n    rgba(255, 250, 205, 0.9) 25%,  /* 浅柠檬色 */\n    rgba(250, 235, 215, 0.85) 50%, /* 古董白 */\n    rgba(255, 228, 181, 0.8) 75%,  /* 小麦色 */\n    rgba(245, 222, 179, 0.75) 100% /* 小麦色深一点 */\n  );\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* 返回按钮 */\n.back-btn {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(139, 110, 99, 0.8);\n  backdrop-filter: blur(10px);\n  color: white;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  z-index: 100;\n}\n\n.back-btn:hover {\n  background: rgba(109, 76, 65, 0.9);\n  transform: translateY(-2px);\n}\n\n/* 中心爱心容器 */\n.heart-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  z-index: 10;\n}\n\n/* 爱心样式 */\n.love-heart {\n  width: 80px;\n  height: 80px;\n  position: relative;\n  cursor: pointer;\n  animation: heartPulse 1.5s ease-in-out infinite;\n  transition: all 0.3s ease;\n}\n\n.love-heart:hover {\n  transform: scale(1.1);\n}\n\n.love-heart::before,\n.love-heart::after {\n  content: '';\n  width: 40px;\n  height: 64px;\n  position: absolute;\n  left: 40px;\n  transform: rotate(-45deg);\n  background: linear-gradient(135deg, #ff1744, #e91e63, #ad1457);\n  border-radius: 32px 32px 0 0;\n  transform-origin: 0 100%;\n  box-shadow: 0 4px 15px rgba(255, 23, 68, 0.3);\n}\n\n.love-heart::after {\n  left: 0;\n  transform: rotate(45deg);\n  transform-origin: 100% 100%;\n}\n\n/* 点击提示文字 */\n.click-hint {\n  margin-top: 20px;\n  font-size: 1.2rem;\n  color: #d63384;\n  font-weight: 600;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n  animation: bounce 2s infinite;\n}\n\n/* 下落的红点 */\n.falling-dot {\n  width: 10px;\n  height: 10px;\n  background: radial-gradient(circle, #ff1744, #c51162);\n  border-radius: 50%;\n  position: absolute;\n  box-shadow: 0 2px 8px rgba(255, 23, 68, 0.4);\n  animation: fallDown 1.5s ease-in forwards; /* 缩短下落时间 */\n}\n\n/* 土壤线条 */\n.soil-line {\n  position: absolute;\n  bottom: 20%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80%;\n  height: 8px;\n  background: linear-gradient(to right, #8d6e63, #6d4c41, #5d4037);\n  border-radius: 4px;\n  box-shadow: 0 2px 10px rgba(93, 64, 55, 0.3);\n  opacity: 1; /* 立即显示，不需要动画 */\n}\n\n/* 主树干 */\n.tree-trunk {\n  position: absolute;\n  bottom: 20%;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  animation: trunkGrow 2s ease-out 2s forwards; /* 提前到2秒开始 */\n}\n\n/* 主树干路径 */\n.main-trunk {\n  fill: none;\n  stroke: url(#trunkGradient);\n  stroke-width: 20;\n  stroke-linecap: round;\n  opacity: 0;\n  animation: drawTrunk 2s ease-out 2s forwards;\n}\n\n/* 树枝 */\n.tree-branch {\n  fill: none;\n  stroke: url(#branchGradient);\n  stroke-linecap: round;\n  opacity: 0;\n}\n\n.tree-branch.branch-1 {\n  stroke-width: 12;\n  animation: drawBranch 1.5s ease-out 4s forwards; /* 提前0.5秒 */\n}\n\n.tree-branch.branch-2 {\n  stroke-width: 10;\n  animation: drawBranch 1.5s ease-out 4.5s forwards;\n}\n\n.tree-branch.branch-3 {\n  stroke-width: 8;\n  animation: drawBranch 1.5s ease-out 5s forwards;\n}\n\n.tree-branch.branch-4 {\n  stroke-width: 8;\n  animation: drawBranch 1.5s ease-out 5.5s forwards;\n}\n\n/* 树叶容器 */\n.tree-leaves {\n  position: absolute;\n  bottom: 20%; /* 与树干底部对齐 */\n  left: 50%;\n  transform: translateX(-50%);\n  width: 300px;\n  height: 300px;\n}\n\n/* SVG树容器 */\n.tree-svg-container {\n  position: absolute;\n  bottom: 20%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 300px;\n  height: 300px;\n  opacity: 0;\n  animation: treeAppear 0.5s ease-out 2s forwards; /* 提前到2秒 */\n}\n\n/* 单个叶子（爱心形状） */\n.leaf {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  opacity: 0;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  /* 以容器中心为基准点定位 */\n  left: 50%;\n  top: 50%;\n  transform-origin: center;\n}\n\n.leaf:hover {\n  transform: scale(1.2);\n}\n\n.leaf::before,\n.leaf::after {\n  content: '';\n  width: 10px;\n  height: 16px;\n  position: absolute;\n  left: 10px;\n  transform: rotate(-45deg);\n  border-radius: 8px 8px 0 0;\n  transform-origin: 0 100%;\n}\n\n.leaf::after {\n  left: 0;\n  transform: rotate(45deg);\n  transform-origin: 100% 100%;\n}\n\n/* 不同颜色的叶子 */\n.leaf.yellow::before,\n.leaf.yellow::after {\n  background: linear-gradient(135deg, #ffd600, #ffb300);\n  box-shadow: 0 2px 6px rgba(255, 214, 0, 0.3);\n}\n\n.leaf.red::before,\n.leaf.red::after {\n  background: linear-gradient(135deg, #ff1744, #e91e63);\n  box-shadow: 0 2px 6px rgba(255, 23, 68, 0.3);\n}\n\n.leaf.orange::before,\n.leaf.orange::after {\n  background: linear-gradient(135deg, #ff6d00, #ff9100);\n  box-shadow: 0 2px 6px rgba(255, 109, 0, 0.3);\n}\n\n.leaf.pink::before,\n.leaf.pink::after {\n  background: linear-gradient(135deg, #e91e63, #ad1457);\n  box-shadow: 0 2px 6px rgba(233, 30, 99, 0.3);\n}\n\n.leaf.green::before,\n.leaf.green::after {\n  background: linear-gradient(135deg, #4caf50, #2e7d32);\n  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);\n}\n\n/* 左侧诗句 */\n.love-poem {\n  position: absolute;\n  left: 10%;\n  top: 35%; /* 从 bottom: 30% 改为 top: 35% */\n  font-size: 1.1rem;\n  color: #5d4037;\n  line-height: 1.8;\n  font-weight: 500;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  animation: poemAppear 3s ease-out 6s forwards;\n}\n\n.poem-line {\n  opacity: 0;\n  animation: typewriter 2s ease-out forwards;\n}\n\n.poem-line:nth-child(1) { animation-delay: 6s; }\n.poem-line:nth-child(2) { animation-delay: 8s; }\n\n/* 天数统计 */\n.days-together {\n  position: absolute;\n  left: 10%;\n  top: 50%; /* 从 bottom: 15% 改为 top: 50% */\n  font-size: 1rem;\n  color: #8d6e63;\n  font-weight: 600;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  animation: daysAppear 1s ease-out 10s forwards;\n}\n\n.days-number {\n  color: #e91e63;\n  font-size: 1.3rem;\n  font-weight: bold;\n  text-shadow: 2px 2px 4px rgba(233, 30, 99, 0.2);\n}\n\n/* 动画定义 */\n@keyframes heartPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }\n  40% { transform: translateY(-10px); }\n  60% { transform: translateY(-5px); }\n}\n\n@keyframes fallDown {\n  0% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  100% {\n    opacity: 0.8;\n    transform: translateY(280px) scale(0.5); /* 调整下落距离，准确落在土壤上 */\n  }\n}\n\n@keyframes soilAppear {\n  from {\n    opacity: 0;\n    width: 0;\n  }\n  to {\n    opacity: 1;\n    width: 80%;\n  }\n}\n\n@keyframes trunkGrow {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes treeAppear {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes drawTrunk {\n  from {\n    opacity: 0;\n    stroke-dasharray: 200;\n    stroke-dashoffset: 200;\n  }\n  to {\n    opacity: 1;\n    stroke-dasharray: 200;\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes drawBranch {\n  from {\n    opacity: 0;\n    stroke-dasharray: 100;\n    stroke-dashoffset: 100;\n  }\n  to {\n    opacity: 1;\n    stroke-dasharray: 100;\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes leafGrow {\n  from {\n    opacity: 0;\n    transform: scale(0) rotate(0deg);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) rotate(360deg);\n  }\n}\n\n@keyframes poemAppear {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes typewriter {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes daysAppear {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 隐藏状态 */\n.hidden {\n  display: none;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .love-heart {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .love-heart::before,\n  .love-heart::after {\n    width: 30px;\n    height: 48px;\n    left: 30px;\n  }\n  \n  .love-heart::after {\n    left: 0;\n  }\n  \n  .click-hint {\n    font-size: 1rem;\n  }\n  \n  .love-poem {\n    left: 5%;\n    font-size: 0.9rem;\n  }\n  \n  .days-together {\n    left: 5%;\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
